<div id="st-tournament-card-tournament-card" class="tournament-card" [class.tournament-card--compact]="compact" (click)="onCardClick()">
  <div id="st-tournament-card-image-container" class="image-container">
    <div id="st-tournament-card-image-clip" class="image-clip">
      <div *ngIf="!imageLoaded && !imageError && resolvedImageUrl" class="image-skeleton" aria-hidden="true"></div>
      <img
        *ngIf="resolvedImageUrl && !imageError; else imageFallback"
        [src]="resolvedImageUrl"
        [alt]="title || 'Tournament Image'"
        class="card-image"
        [loading]="isPriority ? 'eager' : 'lazy'"
        [attr.fetchpriority]="isPriority ? 'high' : null"
        decoding="async"
        width="380"
        height="200"
        (load)="onImageLoad()"
        (error)="onImageError()"
      />
      <ng-template #imageFallback>
        <div class="image-fallback d-flex align-items-center justify-content-center w-100 h-100">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="text-faint" aria-hidden="true">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
            <circle cx="9" cy="9" r="2" />
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
          </svg>
        </div>
      </ng-template>
      <div id="st-tournament-card-media-scrim" class="media-scrim"></div>

      <div id="st-tournament-card-status-badge" class="status-badge" [class]="'status-badge status-' + statusVariant"
        *ngIf="status">
        <span class="status-dot" *ngIf="statusVariant === 'ongoing'"></span>
        {{ eventStatusTitle | translate }}
      </div>

      <div id="st-tournament-card-alert-box" class="alert-box"
        *ngIf="formattedClosesIn && isRegistrationOpen">
        <i class="pi pi-clock"></i>
        <span>{{ formattedClosesIn }}</span>
      </div>

      <!-- Banner Hover Action for New Registration Flow -->
      <div class="banner-hover-overlay" *ngIf="isRegistrationOpen">
        <button
          type="button"
          class="banner-register-btn"
          (click)="onNewRegister($event)"
        >
          <span>{{ 'register_now' | translate }}</span>
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div id="st-tournament-card-info-row" class="date-chip">
      <i class="pi pi-calendar fw-medium"></i>
      <span class="fw-medium">{{ dateRange }}</span>
    </div>
  </div>

  <div id="st-tournament-card-content-container" class="content-container">
    <h3 class="tournament-title" [title]="title">{{ title | capitalizeTitle }}</h3>

    <button type="button" id="st-tournament-card-location-row" class="location-row" *ngIf="location || distanceKm != null"
      (click)="toggleMapDrawer($event)">
      <i class="bi bi-geo-alt-fill fw-medium"></i>
      @if (distanceKm != null) {
        <span class="fs-12 fw-medium">{{ distanceKm }} km</span>
      }
      @if (location) {
        <span class="fw-medium">{{ location }}</span>
      }
    </button>

    <div id="st-tournament-card-footer" class="card-footer">
      <button type="button" id="st-tournament-card-info-row-1" *ngIf="!isBroadcastRoute" class="registered-row"
        (click)="onViewRegister(); $event.stopPropagation()">
        <i class="pi pi-users fw-medium"></i>
        <span class="fw-medium">{{ registeredCount }} {{'registered'|translate}}</span>
      </button>

      <button class="register-btn" [class.not-open]="!isRegistrationOpen"
        (click)="onRegister(); $event.stopPropagation()">
        <span class="register-btn-label">{{ isRegistrationOpen ? ('register_now'|translate)
          : ('view_event_details'|translate) }}</span>
        <i class="pi pi-arrow-right btn-arrow"></i>
      </button>
    </div>
  </div>
</div>
<stupa-map-options-drawer *ngIf="showMapDrawer" [location]="location" (panelClose)="toggleMapDrawer()"
  (openMap)="handleOpenMap($event)"></stupa-map-options-drawer>